import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1eb1f7cf&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=1eb1f7cf&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb1f7cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1eb1f7cf')) {
      api.createRecord('1eb1f7cf', component.options)
    } else {
      api.reload('1eb1f7cf', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1eb1f7cf&scoped=true&", function () {
      api.rerender('1eb1f7cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/compose/examCompose/index.vue"
export default component.exports